import { createContext, useContext } from "react";
import type { UserData } from "../types";

/**
 * Тип контекста пользователя
 */
export type UserContextType = {
  // Данные пользователя
  user: UserData | null;

  // Состояние авторизации
  isLoggedIn: boolean;
  isLoading: boolean;

  // Методы
  login: (userData: UserData) => void;
  logout: () => void;
  updateUser: (userData: Partial<UserData>) => void;
};

const UserContext = createContext<UserContextType | undefined>(undefined);

/**
 * Хук для использования контекста пользователя
 */
export function useUser(): UserContextType {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
}

export { UserContext };
